export default __webpack_public_path__ + "static/media/Jump (9).29e57011.png";